<template>
    <div class="columns full-width is-multiline">
        <div class="column is-12">
            <div class="columns toolbar-box">
                <div class="column is-6">
                    <h1 class="title is-3 between-center">
                        <span>
                            <span>Yearly Comparison</span>
                        </span>
                    </h1>
                </div>
                <div class="column is-3">
                    <o-field>
                        <multicomplete
                            v-model="selectedYears"
                            :is-object="true"
                            :options-prop="years"
                            type="custom"
                            :max="99"
                            field-name="label"
                            placeholder="Years"
                            :value="selectedYears"
                        />
                    </o-field>
                </div>
                <div class="column is-3">
                    <o-field>
                        <o-select :expanded="true" placeholder="Month" v-model="filters.month">
                            <option :value="null">All</option>
                            <option :key="i" :value="i" v-for="(month, i) in months">
                                {{ month }}
                            </option>
                        </o-select>
                    </o-field>
                </div>
            </div>
        </div>

        <div class="column is-12">
          <Bar v-if="chartResults" :data="chartResults" :options="chartOptions" />
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Multiselect  from "@vueform/multiselect"
    import Chart from './YearlyChart.vue'
    import { Bar } from 'vue-chartjs'
    import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

    ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

    export default {
        props: {
            height: {}
        },

        components: {
            Chart,
            Bar,
            Multiselect
        },

        data() {
            return {
                yearlyData: [],
                filters: {
                    month: null
                },
                initialLoad: true,
                months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                chartResults: {
                  labels: [  ],
                  datasets: [ { data: [] } ]
                },
                years: [],
                selectedYears: [],
                chartOptions: {
                  responsive: true
                },
              valuex: ['Java', 'JavaScript'],
            }
        },
        watch: {
            'filters.month'(value) {
                    this.chartData()
            },
            'selectedYears' (value) {
                this.chartData()
            },
            'years' (value) {
                this.chartData()
            }
        },

        mounted() {
            axios.get('/api/billings/yearly')
                .then(res => {
                    this.yearlyData = res.data.data
                    this.fillYears()
                    this.chartData()
                    return res
                })
        },
        methods: {
            fillYears() {
                _.each(this.yearlyData, (months, year) => {
                    if (this.years.indexOf(year) === -1) {
                        this.years.push( { id: year, label: year })
                    }
                })
                this.selectedYears = this.years.slice(this.years.length - 3)
            },
            chartData() {
                let filterMonth = this.filters.month,
                    res = {
                        labels: filterMonth === null ? this.months : [this.months[filterMonth]],
                        datasets: []
                    },
                    colors = [
                        '#CD6869',
                        '#D3799E',
                        '#B997CE',
                        '#81B8E9',
                        '#38D5E4',
                        '#43EBC2',
                        '#96F891',
                        '#EDFC6A',
                        '#75B255',
                        '#3B971D',
                        '#E8769C',
                        '#C108B2',
                        '#A8C0F8',
                        '#A53531',
                        '#89E803',
                        '#B0BC33',
                        '#F3ED3C',
                        '#044A55'
                    ]

                let currentYear = parseInt(moment().format('Y'))
                let i = 0;
                let years = this.selectedYears.map(p => p.id )
                _.each(this.yearlyData, (months, year) => {
                    if(years.includes(year)) {
                        res.datasets.push({
                            label: year,
                            data: filterMonth ? [months[filterMonth+1]] : _.values(months),
                            backgroundColor: colors[i%colors.length]
                        })
                        i++;
                    }
                })

                this.chartResults = res
            }
        }
    }
</script>
